import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { PDLTypography } from "../../../dna";
import "./index.scss";

const HomeHero = () => (
  <Container className="pdl_component_homehero px-0">
    <Row className="d-flex flex-row flex-nowrap align-items-center justify-content-center py-0 m-0">
      <Col
        xs={12}
        sm={6}
        className="pdl_component_homehero_col1 p-0 flex-shrink-1 justify-content-start"
      >
        <div className="pdl_component_homehero_text d-flex flex-column align-items-start gap-5">
          <PDLTypography display size="lg" weight="semibold">
            O conhecimento jurídico na palma da sua mão
          </PDLTypography>
          <PDLTypography size="xl" weight="regular">
            A plataforma LEX facilita a sua rotina, reunindo tudo o que você
            precisa em um só lugar.
          </PDLTypography>
        </div>
      </Col>
      <Col
        xs={12}
        sm={6}
        className="pdl_component_homehero_col2 flex-shrink-1 d-flex align-items-center justify-content-center"
      >
        <div className="pdl_component_homehero_notebook w-100 h-100"></div>
      </Col>
    </Row>
  </Container>
);

export default HomeHero;
